var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayouts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 38,
    viewBox: "0 0 36 38",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.813 9.5a2.375 2.375 0 002.375-2.375v-4.75a2.375 2.375 0 00-4.75 0v4.75A2.375 2.375 0 0017.811 9.5M29.688 9.5a2.375 2.375 0 002.375-2.375v-4.75a2.375 2.375 0 00-4.75 0v4.75A2.375 2.375 0 0029.688 9.5",
    fill: "#D4EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4EEFF",
    d: "M0 38h35.625V4.75H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55B4FC",
    d: "M0 11.875h35.625V4.75H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.938 9.5a2.375 2.375 0 002.375-2.375v-4.75a2.375 2.375 0 00-4.75 0v4.75A2.375 2.375 0 005.937 9.5",
    fill: "#D4EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.313 4.75v2.375a2.375 2.375 0 004.75 0V4.75h-4.75zM5.938 9.5a2.375 2.375 0 002.375-2.375V4.75h-4.75v2.375A2.375 2.375 0 005.937 9.5",
    fill: "#1752F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.813 9.5a2.375 2.375 0 002.375-2.375v-4.75a2.375 2.375 0 00-4.75 0v4.75A2.375 2.375 0 0017.811 9.5",
    fill: "#D4EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.813 9.5a2.375 2.375 0 002.375-2.375V4.75h-4.75v2.375A2.375 2.375 0 0017.811 9.5",
    fill: "#1752F0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4.75 34.438h26.125V11.875H4.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1752F0",
    d: "M12.69 26.329l3.359 3.359L26.125 19.61l-3.358-3.359z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1752F0",
    d: "M16.049 29.688l3.359-3.36-6.244-6.243-3.359 3.36z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayouts);
export default __webpack_public_path__ + "static/media/payouts.4f0b63a9b52f7f12ee0748ad8f52c7eb.svg";
export { ForwardRef as ReactComponent };